<div class="splash-bg">
  <div class="circle circle-1"></div>
  <div class="circle circle-2" [ngClass]="{active: circle2On}"></div>
</div>
